import React, { Component } from "react";
import { connect } from "react-redux";
import RecorderForm from "./components/RecorderForm";
import RecentDisclosures from "./components/RecentDisclosures";
import { loadContactGroups } from "../contacts/actions/contactsActions";

export class RecommendationRecorder extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.loadData();
    }

    render() {
        return (
            <div style={{fontSize: 14, marginTop: 20, marginLeft: 10}}>
                <div style={{float: "left", marginRight: 20, marginBottom: 20}}>
                    <RecorderForm />
                </div>
                <div style={{float: "left"}}>
                    <RecentDisclosures />
                </div>
            </div>
        );
    }
}
RecommendationRecorder.propTypes = {
    loadData: React.PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({ });

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadData: () => {
        dispatch(loadContactGroups());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationRecorder);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/RecommendationRecorder.js
 **/